module.exports = __webpack_public_path__ + "img/mandarin-3.580d75b4.png";